import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FluidIntakeHistoryResponse } from "../../services/api/types/forms/responses/FluidIntakeHistoryResponse";
import { RootState } from "../../services/store";
import { FluidIntakeReportResponse } from "../../services/api/types/forms/responses/FluidIntakeReportResponse";

type ResidentId = number;

interface State {
  fluidIntake: Record<ResidentId, FluidIntakeReportResponse[]>;
}

const initialState: State = {
  fluidIntake: {},
};

export const fluidIntakeSlice = createSlice({
  name: "fluidIntake",
  initialState,
  reducers: {
    storeFluidIntake: (
      state,
      action: PayloadAction<FluidIntakeHistoryResponse>,
    ) => {
      const { data } = action.payload;
      data.forEach((entry) => {
        const residentId = entry.resident.id;
        if (!state.fluidIntake[residentId]) {
          state.fluidIntake[residentId] = [];
        }

        // Check if the entry already exists
        const exists = state.fluidIntake[residentId].some(
          (existingEntry) => existingEntry.id === entry.id,
        );
        if (!exists) {
          state.fluidIntake[residentId].push(entry);
        }
      });
    },
  },
});

export const { storeFluidIntake } = fluidIntakeSlice.actions;

export const selectResidentFluidIntakeLogs = createSelector(
  [
    (state: RootState) => state.fluidIntake?.fluidIntake,
    (_: RootState, residentId?: number) => residentId,
  ],
  (fluidIntake, residentId) =>
    !residentId ? [] : fluidIntake?.[residentId] || [],
);

export default fluidIntakeSlice.reducer;
